import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/content';
import { CtaButton } from '../CtaButton';
export function BeforeAfter() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-76" data-mp="26lutcc89j2bx">
      <div className="mx-auto w-full max-w-5xl" data-id="element-77" data-mp="26k044lpyko21">
        <div className="mx-auto max-w-2xl text-center" data-id="element-78" data-mp="22lsndqvhvmqu">
          <h2 className="font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-79" data-mp="2zb1nkz0op5rd">
            From clinical uncertainty to confidence in every decision
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-graphite/75 sm:text-base" data-id="element-80" data-mp="2ua49axisovv5">
            Every algorithm, protocol and clinical tool was designed to answer
            one question:{' '}
            <em className="font-semibold italic text-ink" data-id="element-81" data-mp="1eux0n85wbhqg">
              what is the next step for this patient?
            </em>
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-82" data-mp="19uitrtg16du0">
          {/* BEFORE */}
          <div className="flex h-full flex-col rounded-2xl bg-white p-5 ring-1 ring-ink/10 sm:p-6" data-id="element-83" data-mp="175vtcop1phib">
            <div className="flex items-center gap-2.5 border-b border-ink/10 pb-4" data-id="element-84" data-mp="1c3xerg9y1swy">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-graphite/10" data-id="element-85" data-mp="y3wb5t2ao7ds">
                <XIcon className="h-4 w-4 text-graphite" aria-hidden="true" data-id="element-86" data-mp="132fxvvoppn77" />
              </span>
              <h3 className="text-sm font-extrabold uppercase tracking-[0.16em] text-graphite" data-id="element-87" data-mp="oe33h359wcet">
                Before
              </h3>
            </div>
            <ul className="mt-4 flex flex-1 flex-col gap-3.5" data-id="element-88" data-mp="feg9v3iscawb">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-89" data-mp="jf9xrww89pp7">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-graphite/45" aria-hidden="true" data-id="element-90" data-mp="jg1mcnreqn5z" />
                  <span className="text-[14px] leading-relaxed text-graphite/75 sm:text-[15px]" data-id="element-91" data-mp="afd57k6pw6ov">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="flex h-full flex-col rounded-2xl bg-ink p-5 ring-1 ring-ink sm:p-6" data-id="element-92" data-mp="27c9aguo148mu">
            <div className="flex items-center gap-2.5 border-b border-white/12 pb-4" data-id="element-93" data-mp="23c79knq4bj8m">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blood" data-id="element-94" data-mp="1yefl63oomf96">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-95" data-mp="2v2lj67r3m9eh" />
              </span>
              <h3 className="text-sm font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-96" data-mp="2r21mt6ecn9te">
                After
              </h3>
            </div>
            <ul className="mt-4 flex flex-1 flex-col gap-3.5" data-id="element-97" data-mp="2h3m4nsxavaw1">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-98" data-mp="1antbk7z14mx2">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-blood" aria-hidden="true" data-id="element-99" data-mp="1al74e9g1w9fd" />
                  <span className="text-[14px] font-medium leading-relaxed text-white/90 sm:text-[15px]" data-id="element-100" data-mp="vl1ozcqjxbf9">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-101" data-mp="15h50h97ammev">
          <CtaButton label="I want to make decisions with this clarity" data-id="element-102" data-mp="1a9elcatjwwaa" />
        </div>
      </div>
    </section>;
}